import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";

import InClinicSearch from "../components/InClinicSearch";
import InClinicTable from "../components/InClinicTable";

const OrdersInClinic = (props) => {
	const [inClinic, setInClinic] = useState([]);
	const [page, setPage] = useState(1);
	const [pageCount, setPageCount] = useState(1);

	//getting the data from search component
	const getOrderData = (data, count) => {
		setInClinic(data);
		setPageCount(count);
	};

	//getting the data from the pagination
	const getPage = (data) => {
		setPage(data);
	};

	return (
		<React.Fragment>
			<Grid container spacing={4}>
				<Grid md={12}>
					<InClinicSearch
						getOrderData={getOrderData}
						page={page}
						rowCount={15}
					/>
				</Grid>
				<Grid md={12}>
					<InClinicTable
						data={inClinic}
						getPage={getPage}
						pageCount={pageCount}
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default OrdersInClinic;
